import * as React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { purple, indigo, lightGreen, cyan } from "@mui/material/colors";

export default function EmptyIcon() {
  return (
    <SvgIcon
      style={{
        maxWidth: "300px",
        width: "100%",
        height: "auto",
        margin: "-40px auto 20px auto",
        textAlign: "center",
        display: "flex",
      }}
    >
      <svg
        x="0px"
        y="0px"
        width="3631.7px"
        height="1247px"
        viewBox="0 0 3631.7 1247"
        enable-background="new 0 0 3631.7 1247"
      >
        <g>
          <g>
            <ellipse
              fill="var(--mui-palette-primary-main)"
              cx="1815.8"
              cy="1123.8"
              rx="1815.8"
              ry="123.3"
            />
            <g>
              <g>
                <path
                  fill="none"
                  stroke="#2C1D1A"
                  stroke-width="40.0111"
                  stroke-miterlimit="10"
                  d="M816.3,1168.9V269.1
					c0-47.9-29.5-86.7-65.8-86.7H476.7c-36.3,0-65.8,38.8-65.8,86.7v899.8"
                />
                <path
                  fill="none"
                  stroke="#2C1D1A"
                  stroke-width="40.0111"
                  stroke-miterlimit="10"
                  d="M2893.6,1169.6V269.8
					c0-47.9-29.5-86.7-65.8-86.7H2554c-36.3,0-65.8,38.8-65.8,86.7v899.8"
                />

                <line
                  fill="none"
                  stroke="#2C1D1A"
                  stroke-width="40.0111"
                  stroke-miterlimit="10"
                  x1="394.3"
                  y1="831.2"
                  x2="2501.9"
                  y2="831.2"
                />

                <line
                  fill="none"
                  stroke="#2C1D1A"
                  stroke-width="40.0111"
                  stroke-miterlimit="10"
                  x1="816.3"
                  y1="924.1"
                  x2="2923.9"
                  y2="924.1"
                />
                <g>
                  <path
                    fill="#A1949B"
                    d="M2853.8,0L236.4,17.9c0,0,22.7,71,33.5,93.3c14.6,30.2,27.2,60.7,60.7,60.7h2523.2V0z"
                  />
                  <path
                    fill="#473C42"
                    d="M3078.8,0h-232v171.9h200.9c17.2,0,31.1-13.9,31.1-31.1V0z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
